import React, { useState, useEffect } from "react";
import { Tooltip, Checkbox, Row, Col } from "antd";
import GenericModal from "../../buttons/genericModal";
import Button from '@mui/material/Button';

const TransactionsDownloadConfigModal = (props) => {
    const [selectedColumns, setSelectedColumns] = useState({});
    const [configAllowed, setConfigAllowed] = useState(true);
    const [dynamicTagColumns, setDynamicTagColumns] = useState([]);

    const transactionInfoKeys = {
        DATE: true,
        TIME: false,
        DESCRIPTION: true,
        "SHORT DESCRIPTION": false,
        AMOUNT: true,
        BALANCE: false,
        METHOD: false,
        "TO/FROM": false,
        "COUNTERPARTY IS INTERNAL": false,
        "COUNTERPARTY TAGS": false,
        "G/L ITEM": false,
        "G/L ACCT": false,
        NOTES: false,
        TAGS: false,
        "CHECK NUMBER": true,
        "REFERENCE NUMBER": true,
    };

    const accountInfoKeys = {
        "ACCOUNT NAME": false,
        "BANK NAME": false,
        "ARPARI ACCOUNT DESCRIPTION": false,
        PURPOSE: false,
        ENTITY: false,
        "ACCOUNT NUMBER LAST 4": false,
    };

    const lockedKeys = ["DATE", "DESCRIPTION", "AMOUNT"];

    useEffect(() => {
        const tagMap = new Map();

        props.transactions?.forEach((item) => {
            item?.account_generic_tags?.forEach(tag => {
                const group = tag.group_name;
                const tagName = tag.name;
                const parentName = typeof tag.parent === "number" ? "Unknown" : tag.parent?.name;

                const value = parentName ? `${parentName} > ${tagName}` : tagName;

                if (!tagMap.has(group)) {
                    tagMap.set(group, []);
                }

                if (!tagMap.get(group).includes(value)) {
                    tagMap.get(group).push(value);
                }
            });
        });

        const newDynamicTags = Array.from(tagMap.keys());
        setDynamicTagColumns(newDynamicTags);

        const dynamicCols = {};
        newDynamicTags.forEach(group => {
            dynamicCols["ACCOUNT_TAGS"] = true;
        });

        setSelectedColumns(prev => ({
            ...transactionInfoKeys,
            ...accountInfoKeys,
            ...dynamicCols,
            DATE: true,
            DESCRIPTION: true,
            AMOUNT: true
        }));
    }, [props.transactions]);

    useEffect(() => {
        if (props.pending) {
            setSelectedColumns({
                DATE: true,
                "TO/FROM": true,
                "ACCOUNT NAME": true,
                "BANK NAME": true,
                DESCRIPTION: true,
                "SHORT DESCRIPTION": true,
                AMOUNT: true,
            });
        }
    }, [props.pending]);

    const handleSectionToggle = (sectionKeys, checked) => {
        const updated = { ...selectedColumns };
        Object.keys(sectionKeys).forEach(key => {
            if (!lockedKeys.includes(key)) {
                updated[key] = checked;
            }
        });
        if (!props.pending) setSelectedColumns(updated);
    };

    const handleCheckboxChange = (label, value) => {
        if (lockedKeys.includes(label)) return;
        setSelectedColumns({ ...selectedColumns, [label]: value });
    };

    const handleSubmit = () => {
        const columnsToExport = props.pending
            ? Object.keys(selectedColumns)
            : Object.keys(selectedColumns).filter(key => selectedColumns[key]);

        const downloadOptions = {
            columns: columnsToExport,
            selectedColumns: selectedColumns,
            dynamicTagColumns: dynamicTagColumns
        };

        props.onSubmit(downloadOptions);
    };

    const renderCheckboxGroup = (title, sectionKeys) => {
        const allChecked = Object.keys(sectionKeys).every(
            key => lockedKeys.includes(key) || selectedColumns[key]
        );

        return (
            <div
                style={{
                    border: '1px solid #ccc',
                    borderRadius: '6px',
                    padding: '16px',
                    marginBottom: '20px',
                    backgroundColor: '#fafafa',
                }}
            >
                <Row style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                    <Checkbox
                        checked={allChecked}
                        onChange={(e) => handleSectionToggle(sectionKeys, e.target.checked)}
                    />
                    <span style={{ marginLeft: 10 }}>{title}</span>
                </Row>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {Object.keys(sectionKeys).map((key) => {
                    const displayLabel = key === "ACCOUNT_TAGS" ? "TAGS" : key;
                    return (
                        <div
                            key={key}
                            style={{
                                width: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                paddingLeft: '20px',
                                marginTop: '5px',
                            }}
                        >
                            <Checkbox
                                checked={selectedColumns[key] || false}
                                disabled={lockedKeys.includes(key)}
                                onChange={(e) => handleCheckboxChange(key, e.target.checked)}
                            />
                            <span style={{ marginLeft: '8px' }}>{displayLabel}</span>
                        </div>
                    );
                })}
                </div>
            </div>
        );
    };

    return (
        <GenericModal
            size="md"
            modalTitle={`Download ${props.reportTitle} on ${props.reportDate?.split('T')[0] || ''}`}
            visible={props.visible}
            handleCancelModal={props.onClose}
            showModal={() => {}}
            modalBody={
                <Col style={{ display: 'flex', flexDirection: 'column' }}>
                    {renderCheckboxGroup("Transaction Information", transactionInfoKeys)}
                    {renderCheckboxGroup("Account Information", { ...accountInfoKeys, ACCOUNT_TAGS: true })}
                    <Row justify="center" align="middle" style={{ marginTop: 10 }}>
                        <div
                            style={{
                                opacity: configAllowed ? 1 : 0.5,
                                pointerEvents: configAllowed ? 'auto' : 'none',
                            }}
                        >
                            <Button
                                disableElevation
                                fullWidth
                                size="medium"
                                variant="contained"
                                color="primary"
                                style={{
                                    cursor: configAllowed ? "pointer" : "not-allowed",
                                }}
                                disabled={!configAllowed}
                                sx={{ fontSize: 14, width: '100px', textTransform: 'none' }}
                                onClick={handleSubmit}
                            >
                                Download
                            </Button>
                        </div>
                    </Row>
                </Col>
            }
        />
    );
};

export default TransactionsDownloadConfigModal;
